module.exports = __webpack_public_path__ + "static/media/mudic-white.d7387e84.svg";